var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.50619 7.87743C6.89895 7.87743 7.23311 7.73853 7.50866 7.46072C7.78436 7.18292 7.92221 6.84895 7.92221 6.45883C7.92221 6.0687 7.78229 5.73671 7.50247 5.46286C7.22279 5.18916 6.88657 5.05231 6.49381 5.05231C6.10105 5.05231 5.76689 5.19121 5.49134 5.46901C5.21564 5.74696 5.07779 6.081 5.07779 6.47113C5.07779 6.86126 5.21771 7.19317 5.49753 7.46687C5.77721 7.74058 6.11343 7.87743 6.50619 7.87743ZM6.5 14.4878C8.18633 13.0222 9.49959 11.5938 10.4398 10.2026C11.3799 8.81137 11.85 7.58461 11.85 6.52231C11.85 4.97909 11.3451 3.69521 10.3352 2.67069C9.32525 1.64617 8.04686 1.13391 6.5 1.13391C4.95314 1.13391 3.67475 1.64617 2.66484 2.67069C1.65493 3.69521 1.14997 4.97909 1.14997 6.52231C1.14997 7.58461 1.62006 8.81137 2.56024 10.2026C3.50041 11.5938 4.81367 13.0222 6.5 14.4878ZM6.5 16C4.33319 14.1702 2.70811 12.4671 1.62478 10.8908C0.541593 9.31448 0 7.85832 0 6.52231C0 4.72896 0.604989 3.19357 1.81497 1.91614C3.02509 0.638714 4.58308 0 6.48894 0C8.3948 0 9.95648 0.638714 11.174 1.91614C12.3913 3.19357 13 4.72896 13 6.52231C13 7.85832 12.4622 9.31126 11.3865 10.8811C10.3108 12.4509 8.682 14.1572 6.5 16Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.94891b22eef18d4bb1978b7002d4309f.svg";
export { ForwardRef as ReactComponent };